export default "__VITE_ASSET__29661480__"